import { EnumBase } from 'hay-core-react';
class TemplateTesteipEnum extends EnumBase {
  constructor() {
    super(
      [
        'main.monitoramentotemplate.testeip.ipfy',
        'main.monitoramentotemplate.testeip.desativado',
      ],
      'main.monitoramentotemplate.testeip.desativado'
    );
  }
}

export default new TemplateTesteipEnum();
